import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import LoaderVisible from "../../helpers/loader";
import LoaderFailed from "../../helpers/loaderFailed";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";

class Level extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "name",
      currentUser: "",
      pageNewCount: false,
      isRequestLoaderFailed: false,
      isRequestLoader: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isHide: false,
      isSmallMobile: false,
      iswebMobile: false,
      isEmptyField: false,
      pageCount: 20,
      id: null,
      category1List: [],
      category1ArryList: ['guna'],
      levelList: [],
      levelListById: [],
      selectedItem: [],
      userID: 0,
      levelInput: "",
      currentPage: 1,
      perPage: 20,
      totalCount: 0,
      requestCount: 0,
      levelData: {},
      searchInput: "",
      isSearch: false,
      mappingList: [],
      mapping: false,
      addcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
      },
      editcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
      },
      levelId: NaN,
      auditLog: [],
      isView: false,
      levelLimitExceed: false,
    };
  }
  componentDidMount() {
    this.setState({ isRequestLoader: true })
    this.getLevelList();
    let user = localStorage.getItem("UserId");
    let Rolevalue = localStorage.getItem("Role").split(",")[0];
    this.state.userID = parseInt(user);
    this.state.currentUser = Rolevalue;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  openAddLevelList = () => {
    this.state.selectedItem = [];
    this.state.isSearch = false;
    this.state.levelLimitExceed = false;
    let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("addLevelScreen")
    );
    myOffcanvas.show();
    this.setState({});
    $("body").addClass("scrollhide");
    if ((this.state.levelList).length > 0) {
      this.state.id = this.state.levelList[(this.state.levelList).length - 1].id + 1;
    }
    this.setState({});
  };

  openRemoveScreen = () => {
    let myOffcanvas = new window.bootstrap.Modal(
      document.getElementById("CancelCourseScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  }

  checkingMap = () => {
    let url = `${API.POST_VALIDATE_LEVELS}`;
    this.setState({
      isRequestLoader: true
    })
    axios({
      method: "POST",
      url: url,
      data: this.state.selectedItem
    })
      .then((res) => {
        if (res.data?.length > 0 && res.data) {
          this.setState({
            mapping: true,
            mappingList: res.data,
            isRequestLoader: false
          }, () => {
            this.openRemoveScreen();
          })
        }
        else {
          this.setState({
            mapping: false,
            isRequestLoader: false
          }, () => {
            this.openRemoveScreen();
          })
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.state.isRequestLoaderFailed = true;
        this.state.isRequestLoader = false;
        this.setState({});
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  }

  getLevelValue = (isView, id) => {
    this.state.isRequestLoader = true;
    this.state.levelLimitExceed = false;
    this.state.id = id || this.state.selectedItem[0];
    this.getLevelListById(id || this.state.selectedItem[0])
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("editLevelScreen"));
    // myOffcanvas.show();
    this.state.isView = isView;
    this.setState({});
    $("body").addClass("scrollhide")
  }

  getLevelList = () => {
    let apiUrl = `${API.GET_LEVEL}?sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.isSearch ? { name: this.state.searchInput } : {}
      data: { name: this.state.searchInput }
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.levelList = res.data.values;
          this.state.isRequestLoader = false;
          this.state.isSearch = false;
          this.state.isEmptyField = false;
          this.state.pageCount = res.data.totalCount;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.state.isRequestLoaderFailed = true;
        this.state.isRequestLoader = false;
        this.setState({});
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  sortTable = (name) => {
    let sortData = this.state.levelList;
    if (sortData.length !== 0) {
      this.state.isRequestLoader = true;
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc"
          this.state.order = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.order = ordernew;
        }
      }
      else {
        this.state.sortBy = name;
        this.state.order = 'asc'
      }
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({ currentPage: 1 }, () => {
        this.getLevelList()
      })

    }
  };

  getLevelListById = (id) => {
    let apiUrl = `${API.GET_LEVEL_BYID}?id=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          let auditLogTemp = res.data.historyLog;
          this.state.levelInput = res.data.name;
          this.state.isRequestLoader = false;
          this.state.editReferenceData = res.data.name;
          this.state.levelId = id;
          this.state.auditLog = auditLogTemp;
          this.state.isRequestLoader = false;
          //  this.state.pageCount = res.data.totalCount ;
          this.setState({});
          let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("editLevelScreen"));
          myOffcanvas.show();
        }

      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  addUpdateLevelList = (name) => {
    this.state.isRequestLoader = true;
    let Url = `${API.GET_EXIST_LEVEL}?level=${this.state.levelData.name}&id=${name == "Add" ? 0 : this.state.levelData.id}`;
    let apiUrl = `${API.PUT_LEVEL}?userId=${this.state.userID}`;
    axios({
      method: "GET",
      url: Url,
    })
      .then((res) => {
        if (res.data == false) {
          axios({
            method: "PUT",
            url: apiUrl,
            data: this.state.levelData,
          })
            .then((res) => {
              if (res.status === 200) {
                this.state.isRequestLoader = false;
                $("body").removeClass("scrollhide")
                this.state.levelInput = "";
                this.state.id = null;
                this.state.selectedItem = [];
                this.state.isHide = true;
                this.setState({});

                if (name == "Update") {
                  this.state.isRequestLoader = false;
                  toast.success("Level edited successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    color: "#fff",
                  });
                  $("#editLevelScreen").removeClass('show');
                }
                else if (name == "Add") {
                  this.state.isRequestLoader = false;
                  toast.success("Level added successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    color: "#fff",
                  });
                  $("#addLevelScreen").removeClass('show');
                }
                this.getLevelList();
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              this.state.isRequestLoader = false;
              // if (name == "Update") {
              //   toast.error("Failed to update Level", {
              //     position: toast.POSITION.TOP_RIGHT,
              //     color: "#fff",
              //   });
              // }
              // else if (name == "Add") {
              //   toast.error("Failed to add Level", {
              //     position: toast.POSITION.TOP_RIGHT,
              //     color: "#fff",
              //   });
              // }
              swal("Error!", "Something went wrong. Please try again.", "warning");
              console.log(error);
            });
        }
        else {
          this.setState({ isRequestLoader: false, isRequestFailed: false });

          toast.error(
            "This Level is already given. Please add another Level.",
            {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            }
          );

        }
      })
  };

  addLevelList = () => {
    if (this.state.levelInput?.trim() !== "") {
      this.state.levelData = {
        name: this.state.levelInput,
      }
      this.state.isEmptyField = false;
      this.state.isRequestLoader = true;
      this.setState({})
      this.addUpdateLevelList("Add");
    }
    else {
      this.setState({ isEmptyField: true })
    }
  }

  updateLevelList = () => {
    if (this.state.levelInput?.trim() !== "") {
      //   if(this.state.editReferenceData === this.state.levelInput.trim()){
      //     this.state.isSameData = true;
      //     this.setState({})
      // }
      // else{
      this.state.levelData = {
        id: this.state.id,
        name: this.state.levelInput,
      }
      this.state.isEmptyField = false;
      this.state.isSameData = false;
      this.state.isRequestLoader = false;
      this.setState({})
      this.addUpdateLevelList("Update");
      // }
    }
    else {
      this.setState({ isEmptyField: true, isSameData: false })
    }
  }

  // clearWarningMesssage = () => {
  //   this.setState({
  //       // selectedItem : [],
  //       mappingList: [],
  //       mapping : false
  //   })
  //   $("body").removeClass("scrollhide");
  //  }

  deleteLevelList = () => {
    this.state.isRequestLoader = true;
    let apiUrl = `${API.DELETE_LEVEL}?userId=${this.state.userID}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: this.state.selectedItem,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.levelInput = "";
          this.state.selectedItem = [];
          this.setState({});
          toast.success("Level removed successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          $("body").removeClass("scrollhide");
          this.getLevelList();
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.state.isRequestLoader = false;
        // toast.error("Failed to remove Level", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   color: "#fff",
        // });
        swal("Error!", "Something went wrong. Please try again.", "warning");
        $("body").removeClass("scrollhide");
        console.log(error);
      });
  }



  clearLevelList = () => {
    this.state.levelInput = "";
    this.state.selectedItem = [];
    this.state.isEmptyField = false;
    this.state.levelData = {};
    this.state.data = [];
    this.state.isSearch = false;
    this.state.order = "desc";
    this.state.levelListById = "";
    $("#addLevelScreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide")
    this.setState({})
  };

  fetchPaginationList = (pageNumber, pageSize) => {
    this.state.isRequestLoader = true;
    this.state.perPage = pageSize;
    this.state.currentPage = pageNumber;
    this.setState({})
    this.getLevelList();
  };

  handleCheckbox = (id) => {
    const { selectedItem } = this.state;
    if (selectedItem.length == 0) {
      selectedItem.push(id);
    } else {
      if (selectedItem && selectedItem.filter((i) => i == id).length == 1) {
        selectedItem.map((i, ind) => (i == id ? selectedItem.splice(ind, 1) : ""));
      } else {
        selectedItem.push(id);
      }
    }
    this.setState({});
  };

  handleCheckboxTop = () => {
    let data = [];
    if (
      this.state.selectedItem?.length !=
      this.state.levelList?.length &&
      this.state.selectedItem?.length > 0 &&
      this.state.levelList?.length > 0
    ) {
      this.state.levelList?.map((r) =>
        data.push(r.id)
      );
    }
    if (
      this.state.selectedItem?.length == 0 &&
      this.state.levelList?.length > 0
    ) {
      this.state.levelList?.map((r) =>
        data.push(r.id)
      );
    }
    if (
      this.state.selectedItem?.length ==
      this.state.levelList?.length &&
      this.state.levelList?.length > 0
    ) {
      data = [];
    }
    this.state.selectedItem = data;
    this.setState({});
  };

  openSearchFilter = () => {

    this.setState({
      selectedItem: []
    })
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addLevelScreen")
    );
    myOffcanvas.show();
    this.state.isSearch = true;
    this.state.isFieldEmpty = false;
    this.state.levelLimitExceed = false;
    $("body").addClass("scrollhide");
  }

  searchLevel = () => {
    if (this.state.searchInput?.trim() !== "") {
      this.state.isEmptyField = false;
      this.state.isRequestLoader = true;
      this.setState({})
      $("#addLevelScreen").removeClass('show');
      $("body").removeClass("scrollhide")
      this.getLevelList();
    }
    else {
      this.setState({ isEmptyField: true })
    }
  }

  clearSearchFields = () => {
    this.setState({
      isSearch: false,
      searchInput: "",
      isRequestLoader: true
    }, () => this.getLevelList())
    $("#addLevelScreen").removeClass('show');
    $("body").removeClass("scrollhide")

  }

  handleSearchAddInput = (e) => {
    if (this.state.isSearch) {
      this.setState({ searchInput: e.target.value })
    } else {
      if (e.target.value.length > 0) {
        if (e.target.value.trim().length > 250) {
          this.setState({ levelLimitExceed: true });
        } else {
          // this.setState({levelLimitExceed:false});
          this.setState({ levelInput: e.target.value, levelLimitExceed: false })
        }
      } else {
        this.setState({ levelInput: "" })
      }

    }


  }

  handleEditInput = (e) => {
    if (e.target.value.length > 0) {
      if (e.target.value.trim().length > 250) {
        this.setState({ levelLimitExceed: true });
      } else {
        // this.setState({levelLimitExceed:false});
        this.setState({ levelInput: e.target.value, levelLimitExceed: false })
      }
    } else {
      this.setState({ levelInput: "" })
    }
    // this.state.levelInput = e.target.value;
    // this.setState({})

  }
  render() {
    const { isMobile, levelList, isSmallMobile, isEmptyField, isRequestLoader, selectedItem, isRequestLoaderFailed, pageCount, isRadioMobile, sortBy, order } = this.state;
    const { menuToggle } = this.props;
    return (
      <>
        <Toaster />
        {$("#addLevelScreen").hasClass("show") || $("#editLevelScreen").hasClass("show") ? (<div className="viewbar-overlay"></div>) : (<></>)}
        <div className={`${isMobile ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>

          <LoaderVisible isLoader={isRequestLoader} />
          {/* <LoaderFailed isLoader={isRequestLoaderFailed} /> */}

          <div className="head-fixed-company">
            {isMobile == true ? (
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title">Level</div>
              </div>) : (
              <div className="title">
                <CommonIcon fileName="levelActive" /><span className="pl-10 head-span">Level</span>
              </div>)}
            <div className={`${isMobile ? "" : ""} position-relative border-bottom`}>
              <div className={`col-12 d-flex justify-content-start pl-10 ${menuToggle ? "width-100" : "width-filter"} ${isMobile ? "pr-0" : ""}`}>
                <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.openAddLevelList()}>
                  <CommonIcon fileName="addIcon" /><span className={`subhead-span p-2`}>Add</span>
                </button>
                {selectedItem?.length === 1 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.getLevelValue(false, NaN)}>
                    <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                  </button>}
                {selectedItem?.length !== 0 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`}
                    //  data-bs-toggle="modal" data-bs-target="#CancelCourseScreen"
                    onClick={this.checkingMap}
                  >
                    <CommonIcon fileName="RemoveIcon" /><span className={`subhead-span p-2`}>Remove</span>
                  </button>}
                <div
                  className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                    }`}
                >
                  <button
                    className="displaybutton"
                    onClick={this.openSearchFilter}
                  >
                    <span>
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </button>
                </div>
              </div>

            </div>
          </div>
          <div className={`${isMobile ? "favorite-mobile-table1" : "favorite-table1"} table-responsive w-100`}>
            <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-level" : "table-scroll-xy top-upcoming-level")} table-list-view-bottom`} >
              <table className={`table  fileListTable2 table-borderless table-hover ${isMobile ? "" : ""} table-responsive`}>
                <thead>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="request"
                        checked={
                          selectedItem?.length > 0 &&
                            selectedItem?.length ==
                            levelList?.length
                            ? true
                            : false
                        }
                        onClick={() => this.handleCheckboxTop()}
                      />
                    </td>
                    <td className="cursor-pointer min-width-skill-masterdata pl-20" onClick={() => this.sortTable("name")}>
                      <span>Level</span>
                      {sortBy === "name" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                    </td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {levelList?.length !== 0 ? (levelList?.map((item, index) => (
                    <tr key={index} className="background-color-table">
                      <td>
                        <input
                          type="checkbox"
                          name="request"
                          className="checkboxes t-input"
                          checked={
                            selectedItem?.filter(
                              (r) => r == item.id
                            )?.length > 0
                              ? true
                              : false
                          }
                          onClick={() => this.handleCheckbox(item.id)}
                        />
                      </td>
                      <td className="pl-20  min-width-skill-masterdata">
                        <span className="tablefilename cursor-pointer font-wei-600" onClick={() => this.getLevelValue(true, item.id)}>{item.name}</span>
                      </td>
                      <td></td>
                    </tr>))) : (
                    <tr> <td colSpan={8} className="table-nodata">{"No record found"}</td> </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Add offcanvas */}
          <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="addLevelScreen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">{this.state.isSearch ? "Search" : "Add level"}</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={() => { !this.state.isSearch && this.clearLevelList() }}>
                <CommonIcon fileName="CrossIcon" />
              </button>
            </div>
            <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="levelIcon" />
                      <span className="pl-10 properties-search-span">Level</span>
                      {
                        this.state.isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                      }
                    </label>
                    <input className={` form-control border-radius mt-2 font-size-12 ${this.state.levelLimitExceed ? "Error-border" : ""}`}
                      onChange={(e) => this.handleSearchAddInput(e)}
                      style={{ borderColor: isEmptyField ? "#d12232" : "" }}
                      value={this.state.isSearch ? this.state.searchInput : this.state.levelInput} />
                    {isEmptyField ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)}
                    {this.state.levelLimitExceed ? (
                      <span className="spanErrMsg">Value must be less than 250 characters</span>
                    ) : (<></>)}
                  </div>
                </div>
              </div>
              <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                {/* <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => {this.state.isSearch ? this.searchLevel() : this.addLevelList()}}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10" >{this.state.isSearch ? "Search" : "Submit"}</span>
                </button> */}
                {
                  this.state.isSearch &&
                  <button className="btn rejectbutton" onClick={() => this.clearSearchFields()} >
                    <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                    <span className="px-1">Clear</span> </button>
                }
                <button
                  className={`btn approvebutton d-flex gap-1 ${this.state.isSearch ? "mx-2" : ""}`}
                  onClick={() => { this.state.isSearch ? this.searchLevel() : this.addLevelList() }}>
                  {this.state.isSearch ? <span><CommonIcon fileName="searchableIcon" /></span> : <span><CommonIcon fileName="ButtonSubmitIcon" /></span>}
                  <span className="model-label pl-vendor3 pl-2">{this.state.isSearch ? "Search" : "Submit"}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Edit offcanvas */}
          <div className={`offcanvas offcanvas-end offcanvasStyle ${this.state.isView ? "audit-offcanvas" : ''}`} tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="editLevelScreen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">{this.state.isView ? 'Level' : 'Edit level'}</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`}
                data-bs-dismiss="offcanvas" onClick={this.clearLevelList}>
                <CommonIcon fileName="CrossIcon" />
              </button>
            </div>
            <div className="offcanvas-body px-4 pt-0">
              {
                this.state.isView && <button className={`displaybutton ${isRadioMobile ? "pr-5" : "p-0"}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.getLevelValue(false, this.state.levelId)}>
                  <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                </button>
              }
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon className="properties-img-2" fileName="levelIcon" />
                      <span className="pl-10 properties-search-span">Level</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input className={` form-control border-radius mt-2 font-size-12 ${this.state.levelLimitExceed ? "Error-border" : ""}`}
                      value={this.state.levelInput}
                      onChange={(e) => this.handleEditInput(e)}
                      disabled={this.state.isView}
                      style={{ borderColor: isEmptyField ? "#d12232" : "" }}
                    />
                    {isEmptyField ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)}
                    {this.state.levelLimitExceed ? (
                      <span className="spanErrMsg">Value must be less than 250 characters</span>
                    ) : (<></>)}
                    {/* {isSameData ? (
                                            <span className="send-rework-label">
                                                Changes required
                                            </span>
                                        ) : (
                                            <></>
                                        )} */}
                  </div>
                </div>
              </div>
              {
                !this.state.isView && <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                  <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => this.updateLevelList()}>
                    <CommonIcon fileName="ButtonSubmitIcon" />
                    <span className="model-label pl-10">Update</span>
                  </button>
                </div>
              }
              {
                (this.state.isView || !this.state.isView) && this.state.auditLog?.length > 0 && <div>
                  <div className="pt-3">
                    <h6 className="modal-title">Audit log</h6>
                  </div>
                  <div className="audit-table-wrapper audit-scroll-css">
                    <table className="px-3 audit-table w-100">
                      <thead>
                        <tr className="border-bottom">
                          <th className="p-rem">
                            Action
                          </th>
                          <th className="p-rem">
                            Action By
                          </th>
                          <th className="p-rem wid-45">
                            Description
                          </th>
                          <th className="p-rem">
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.auditLog?.map((x, i) => (
                            <tr className="border-bottom" key={i}>
                              <td className="p-rem" key={`${i}-action`}>{x.action ? x.action : "-"}</td>
                              <td className="p-rem" key={`${i}-actionby`}>{x.actionBy ? x.actionBy : "-"}</td>
                              <td className="p-rem" key={`${i}-desc`}>
                                {x.description ? x.description : "-"}
                              </td>
                              <td className="p-rem" key={`${i}-created`}>
                                {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        {/* Modal - Warning */}
        <WarningComponent
          message={this.state.mapping ? (this.state.mappingList?.length > 1 ? "The following levels are tagged to roles" : "The following level is tagged to role") : (this.state.selectedItem?.length > 1 ? "Are you sure you want to remove these Levels ?" : "Are you sure you want to remove this Level ?")}
          isMobile={this.state.isMobile}
          onYesClick={this.deleteLevelList}
          // warningMessage={this.clearWarningMesssage}
          type={this.state.mapping ? (this.state.mappingList?.length > 1 ? "Levels" : "Level") : ""}
          mappingData={this.state.mapping ? this.state.mappingList : []}
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={pageCount}
          reset={this.state.pageNewCount}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Level)
);
